// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { createAndAssociateRequestToJson, createAndAssociateResponseFromJson, getCreatePasswordUrlRequestToJson, getCreatePasswordUrlResponseFromJson, getOnboardingEmailTemplateRequestToJson, getOnboardingEmailTemplateResponseFromJson, getWelcomeEmailTemplateRequestToJson, getWelcomeEmailTemplateResponseFromJson, listNamespaceDetailsRequestToJson, listNamespaceDetailsResponseFromJson, listUsersForBusinessRequestToJson, listUsersForBusinessResponseFromJson, listUsersForBusinessV2RequestToJson, listUsersForBusinessV2ResponseFromJson, listUsersForBusinessesRequestToJson, listUsersForBusinessesResponseFromJson, removeUserFromBusinessRequestToJson, requestShortOTPCodeRequestToJson, requestShortOTPCodeResponseFromJson, sendOnboardingEmailRequestToJson, sendWelcomeEmailRequestToJson, startOnboardingRequestToJson, startOnboardingResponseFromJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function getCreatePasswordUrl(request) {
    const raw = await fetchRpc('business_center.v1.User/GetCreatePasswordUrl', getCreatePasswordUrlRequestToJson(request));
    return getCreatePasswordUrlResponseFromJson(raw);
}
export function getCreatePasswordUrl$(request, options) {
    return defer(() => getCreatePasswordUrlWithTransport$(getGlobalTransport(), request, options));
}
export function getCreatePasswordUrlWithTransport$(transport, request, options) {
    return transport
        .post('business_center.v1.User/GetCreatePasswordUrl', getCreatePasswordUrlRequestToJson(request), options)
        .pipe(map(resp => getCreatePasswordUrlResponseFromJson(resp)));
}
export async function sendWelcomeEmail(request) {
    await fetchRpc('business_center.v1.User/SendWelcomeEmail', sendWelcomeEmailRequestToJson(request));
}
export function sendWelcomeEmail$(request, options) {
    return defer(() => sendWelcomeEmailWithTransport$(getGlobalTransport(), request, options));
}
export function sendWelcomeEmailWithTransport$(transport, request, options) {
    return transport
        .post('business_center.v1.User/SendWelcomeEmail', sendWelcomeEmailRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function getWelcomeEmailTemplate(request) {
    const raw = await fetchRpc('business_center.v1.User/GetWelcomeEmailTemplate', getWelcomeEmailTemplateRequestToJson(request));
    return getWelcomeEmailTemplateResponseFromJson(raw);
}
export function getWelcomeEmailTemplate$(request, options) {
    return defer(() => getWelcomeEmailTemplateWithTransport$(getGlobalTransport(), request, options));
}
export function getWelcomeEmailTemplateWithTransport$(transport, request, options) {
    return transport
        .post('business_center.v1.User/GetWelcomeEmailTemplate', getWelcomeEmailTemplateRequestToJson(request), options)
        .pipe(map(resp => getWelcomeEmailTemplateResponseFromJson(resp)));
}
export async function sendOnboardingEmail(request) {
    await fetchRpc('business_center.v1.User/SendOnboardingEmail', sendOnboardingEmailRequestToJson(request));
}
export function sendOnboardingEmail$(request, options) {
    return defer(() => sendOnboardingEmailWithTransport$(getGlobalTransport(), request, options));
}
export function sendOnboardingEmailWithTransport$(transport, request, options) {
    return transport
        .post('business_center.v1.User/SendOnboardingEmail', sendOnboardingEmailRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function getOnboardingEmailTemplate(request) {
    const raw = await fetchRpc('business_center.v1.User/GetOnboardingEmailTemplate', getOnboardingEmailTemplateRequestToJson(request));
    return getOnboardingEmailTemplateResponseFromJson(raw);
}
export function getOnboardingEmailTemplate$(request, options) {
    return defer(() => getOnboardingEmailTemplateWithTransport$(getGlobalTransport(), request, options));
}
export function getOnboardingEmailTemplateWithTransport$(transport, request, options) {
    return transport
        .post('business_center.v1.User/GetOnboardingEmailTemplate', getOnboardingEmailTemplateRequestToJson(request), options)
        .pipe(map(resp => getOnboardingEmailTemplateResponseFromJson(resp)));
}
export async function startOnboarding(request) {
    const raw = await fetchRpc('business_center.v1.User/StartOnboarding', startOnboardingRequestToJson(request));
    return startOnboardingResponseFromJson(raw);
}
export function startOnboarding$(request, options) {
    return defer(() => startOnboardingWithTransport$(getGlobalTransport(), request, options));
}
export function startOnboardingWithTransport$(transport, request, options) {
    return transport
        .post('business_center.v1.User/StartOnboarding', startOnboardingRequestToJson(request), options)
        .pipe(map(resp => startOnboardingResponseFromJson(resp)));
}
export async function createAndAssociate(request) {
    const raw = await fetchRpc('business_center.v1.User/CreateAndAssociate', createAndAssociateRequestToJson(request));
    return createAndAssociateResponseFromJson(raw);
}
export function createAndAssociate$(request, options) {
    return defer(() => createAndAssociateWithTransport$(getGlobalTransport(), request, options));
}
export function createAndAssociateWithTransport$(transport, request, options) {
    return transport
        .post('business_center.v1.User/CreateAndAssociate', createAndAssociateRequestToJson(request), options)
        .pipe(map(resp => createAndAssociateResponseFromJson(resp)));
}
export async function listUsersForBusiness(request) {
    const raw = await fetchRpc('business_center.v1.User/ListUsersForBusiness', listUsersForBusinessRequestToJson(request));
    return listUsersForBusinessResponseFromJson(raw);
}
export function listUsersForBusiness$(request, options) {
    return defer(() => listUsersForBusinessWithTransport$(getGlobalTransport(), request, options));
}
export function listUsersForBusinessWithTransport$(transport, request, options) {
    return transport
        .post('business_center.v1.User/ListUsersForBusiness', listUsersForBusinessRequestToJson(request), options)
        .pipe(map(resp => listUsersForBusinessResponseFromJson(resp)));
}
export async function listUsersForBusinessV2(request) {
    const raw = await fetchRpc('business_center.v1.User/ListUsersForBusinessV2', listUsersForBusinessV2RequestToJson(request));
    return listUsersForBusinessV2ResponseFromJson(raw);
}
export function listUsersForBusinessV2$(request, options) {
    return defer(() => listUsersForBusinessV2WithTransport$(getGlobalTransport(), request, options));
}
export function listUsersForBusinessV2WithTransport$(transport, request, options) {
    return transport
        .post('business_center.v1.User/ListUsersForBusinessV2', listUsersForBusinessV2RequestToJson(request), options)
        .pipe(map(resp => listUsersForBusinessV2ResponseFromJson(resp)));
}
export async function listUsersForBusinesses(request) {
    const raw = await fetchRpc('business_center.v1.User/ListUsersForBusinesses', listUsersForBusinessesRequestToJson(request));
    return listUsersForBusinessesResponseFromJson(raw);
}
export function listUsersForBusinesses$(request, options) {
    return defer(() => listUsersForBusinessesWithTransport$(getGlobalTransport(), request, options));
}
export function listUsersForBusinessesWithTransport$(transport, request, options) {
    return transport
        .post('business_center.v1.User/ListUsersForBusinesses', listUsersForBusinessesRequestToJson(request), options)
        .pipe(map(resp => listUsersForBusinessesResponseFromJson(resp)));
}
export async function removeUserFromBusiness(request) {
    await fetchRpc('business_center.v1.User/RemoveUserFromBusiness', removeUserFromBusinessRequestToJson(request));
}
export function removeUserFromBusiness$(request, options) {
    return defer(() => removeUserFromBusinessWithTransport$(getGlobalTransport(), request, options));
}
export function removeUserFromBusinessWithTransport$(transport, request, options) {
    return transport
        .post('business_center.v1.User/RemoveUserFromBusiness', removeUserFromBusinessRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function requestShortOTPCode(request) {
    const raw = await fetchRpc('business_center.v1.User/RequestShortOTPCode', requestShortOTPCodeRequestToJson(request));
    return requestShortOTPCodeResponseFromJson(raw);
}
export function requestShortOTPCode$(request, options) {
    return defer(() => requestShortOTPCodeWithTransport$(getGlobalTransport(), request, options));
}
export function requestShortOTPCodeWithTransport$(transport, request, options) {
    return transport
        .post('business_center.v1.User/RequestShortOTPCode', requestShortOTPCodeRequestToJson(request), options)
        .pipe(map(resp => requestShortOTPCodeResponseFromJson(resp)));
}
export async function listNamespaceDetails(request) {
    const raw = await fetchRpc('business_center.v1.User/ListNamespaceDetails', listNamespaceDetailsRequestToJson(request));
    return listNamespaceDetailsResponseFromJson(raw);
}
export function listNamespaceDetails$(request, options) {
    return defer(() => listNamespaceDetailsWithTransport$(getGlobalTransport(), request, options));
}
export function listNamespaceDetailsWithTransport$(transport, request, options) {
    return transport
        .post('business_center.v1.User/ListNamespaceDetails', listNamespaceDetailsRequestToJson(request), options)
        .pipe(map(resp => listNamespaceDetailsResponseFromJson(resp)));
}
